<p-editor [formControl]="control()" [style]="styles()"/>
